import React, { useState } from 'react';
import { MdBusiness, MdLocationOn, MdVisibility, MdReceipt, MdAdd, MdFileUpload, MdFileDownload, MdSwapHoriz, MdSearch, MdFilterList, MdStore, MdEdit } from 'react-icons/md';
import { exportTradersToExcel } from '../../utils/excelUtils';
import OperationModal from './OperationModal';
import ExcelImportModal from './ExcelImportModal';
import ReactPaginate from 'react-paginate';
import TableLoadingWrapper from './TableLoadingWrapper';
import EditTraderModal from './EditTraderModal'; // Import the Edit modal
import { API_BASE_URL } from '../../config/api'; 
import '../../styles/views.css';

const TradersView = ({
  pagedFilteredData,
  allData, // Add this to get all data for export
  searchTerm,
  setSearchTerm,
  pageCount,
  handlePageClick,
  loading,
  userRole,
  userMmdaId,
  setViewTrader,
  setIsViewTraderModalOpen,
  setIsAddTraderModalOpen,
  setReassignTrader,
  setIsReassignTraderModalOpen,
  readOnly = false, // MMDA admins can now register traders
  groups, // Add groups prop
  mmdas, // Add mmdas prop
  zones, // Add zones prop
  nationalIdTypes, // Add nationalIdTypes prop
  showPopup, // Add showPopup prop
  fetchData, // Add fetchData prop
}) => {
  const [isMobile, setIsMobile] = useState(false);

  // Modal states
  const [showExportModal, setShowExportModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [isEditTraderModalOpen, setIsEditTraderModalOpen] = useState(false); // State for Edit modal
  const [editTrader, setEditTrader] = useState(null); // State for trader being edited

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Handle export with modal
  const handleExport = () => {
    const dataToExport = allData || pagedFilteredData;
    const success = exportTradersToExcel(dataToExport, 'traders_export.xlsx');

    setShowExportModal(true);
    setTimeout(() => setShowExportModal(false), 3000); // Auto close after 3 seconds
  };

  // Handle import
  const handleImport = (result) => {
    console.log('Import result:', result);
    // Refresh data here if needed
  };

  // Handle operation success
  const handleOperationSuccess = (operation, itemType, itemName, details) => {
    if (showPopup) {
      showPopup(`${operation} successful!`, 'success');
    }
    if (fetchData) {
      fetchData();
    }
  };

  // Handle operation error
  const handleOperationError = (operation, itemType, itemName, error) => {
    if (showPopup) {
      showPopup(`${operation} failed: ${error}`, 'error');
    }
  };

  // Handle add trader
  const handleAddTrader = () => {
    setShowAddModal(true);
  };

  const confirmAddTrader = () => {
    setShowAddModal(false);
    setIsAddTraderModalOpen(true);
  };
  return (
    <>
      {/* Enhanced Traders Management Header */}
      <div style={{
        marginBottom: 24,
        padding: isMobile ? '15px 18px' : '20px 24px',
        backgroundColor: '#fff',
        borderRadius: 12,
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        border: '1px solid #f0f0f0'
      }}>
        <div style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: isMobile ? 'flex-start' : 'center',
          justifyContent: isMobile ? 'flex-start' : 'space-between',
          gap: isMobile ? '12px' : '0',
          marginBottom: 16
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <MdStore size={24} style={{ color: '#1976d2' }} />
            <h3 style={{ margin: 0, color: '#333', fontSize: 18, fontWeight: '600' }}>
              Traders Management
            </h3>
            <span style={{
              padding: '4px 12px',
              backgroundColor: '#e3f2fd',
              color: '#1976d2',
              borderRadius: '12px',
              fontSize: '12px',
              fontWeight: '600'
            }}>
              {pagedFilteredData?.length || 0} Traders
            </span>
          </div>

          <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: 8, width: isMobile ? '100%' : 'auto' }}>
            <button
              onClick={() => setShowImportModal(true)}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 6,
                padding: isMobile ? '6px 10px' : '8px 12px',
                backgroundColor: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: 6,
                cursor: 'pointer',
                fontSize: isMobile ? 11 : 12,
                fontWeight: '600',
                width: isMobile ? '100%' : 'auto'
              }}
            >
              <MdFileUpload size={16} />
              Import
            </button>

            <button
              onClick={handleExport}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 6,
                padding: isMobile ? '6px 10px' : '8px 12px',
                backgroundColor: '#6c757d',
                color: 'white',
                border: 'none',
                borderRadius: 6,
                cursor: 'pointer',
                fontSize: isMobile ? 11 : 12,
                fontWeight: '600',
                width: isMobile ? '100%' : 'auto'
              }}
            >
              <MdFileDownload size={16} />
              Export
            </button>

            <button
              onClick={handleAddTrader}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 8,
                padding: isMobile ? '8px 12px' : '10px 16px',
                backgroundColor: '#28a745',
                color: 'white',
                border: 'none',
                borderRadius: 8,
                cursor: 'pointer',
                fontSize: isMobile ? 13 : 14,
                fontWeight: '600',
                boxShadow: '0 2px 4px rgba(40, 167, 69, 0.3)',
                transition: 'all 0.2s ease',
                width: isMobile ? '100%' : 'auto'
              }}
              onMouseEnter={e => {
                e.currentTarget.style.backgroundColor = '#218838';
                e.currentTarget.style.transform = 'translateY(-1px)';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(40, 167, 69, 0.4)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.backgroundColor = '#28a745';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 4px rgba(40, 167, 69, 0.3)';
              }}
            >
              <MdAdd size={18} />
              {isMobile ? 'Register' : 'Register Trader'}
            </button>
          </div>
        </div>

        {/* Enhanced Search Controls */}
        <div style={{ position: 'relative', maxWidth: 400 }}>
          <MdSearch size={20} style={{
            position: 'absolute',
            left: 12,
            top: '50%',
            transform: 'translateY(-50%)',
            color: '#666'
          }} />
          <input
            type="text"
            placeholder="Search traders by business name, zone, or status..."
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            style={{
              width: '100%',
              padding: '10px 12px 10px 40px',
              borderRadius: 8,
              border: '1px solid #ddd',
              fontSize: 14,
              outline: 'none',
              transition: 'border-color 0.2s ease',
              boxSizing: 'border-box'
            }}
            onFocus={e => e.target.style.borderColor = '#1976d2'}
            onBlur={e => e.target.style.borderColor = '#ddd'}
          />
        </div>
      </div>

      {/* Traders Table */}
      <TableLoadingWrapper loading={loading}>
        <div style={{ overflowX: 'auto' }}>
          <table>
            <thead>
              <tr>
                <th>Business Name</th>
                <th>Zone</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {pagedFilteredData.map((row, i) => (
                <tr key={i} style={{ cursor: 'default' }}>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>

                      <strong>{row.business_name}</strong>
                    </div>
                  </td>


                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>

                      <span style={{
                        padding: '4px 8px',
                        backgroundColor: '#e3f2fd',
                        borderRadius: 4,
                        fontSize: 12,
                        fontWeight: 'bold',
                        color: '#1976d2'
                      }}>
                        {row.zone_name || 'Not Assigned'}
                      </span>
                    </div>
                  </td>
<td>
                    <span style={{
                      padding: '4px 8px',
                      borderRadius: 4,
                      fontSize: 12,
                      fontWeight: 'bold',
                      backgroundColor: row.status === 'active' ? '#e8f5e8' : '#ffebee',
                      color: row.status === 'active' ? '#2e7d32' : '#c62828'
                    }}>
                      {(row.status || 'active').charAt(0).toUpperCase() + (row.status || 'active').slice(1)}
                    </span>
                  </td>
                  <td>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button
                        onClick={() => {
                          setViewTrader(row);
                          setIsViewTraderModalOpen(true);
                        }}
                        style={{
                          padding: '6px 12px',
                          backgroundColor: '#1976d2',
                          color: 'white',
                          border: 'none',
                          borderRadius: 4,
                          cursor: 'pointer',
                          fontSize: 12,
                          display: 'flex',
                          alignItems: 'center',
                          gap: 4
                        }}
                      >
                        <MdVisibility size={14} />
                        View Details
                      </button>
                      <button
                        onClick={() => {
                          setReassignTrader(row);
                          setIsReassignTraderModalOpen(true);
                        }}
                        style={{
                          padding: '6px 12px',
                          backgroundColor: '#ff9800',
                          color: 'white',
                          border: 'none',
                          borderRadius: 4,
                          cursor: 'pointer',
                          fontSize: 12,
                          display: 'flex',
                          alignItems: 'center',
                          gap: 4
                        }}
                      >
                        <MdSwapHoriz size={14} />
                        Reassign
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </TableLoadingWrapper>

      {/* Edit Trader Modal */}
      <EditTraderModal
        isOpen={isEditTraderModalOpen}
        onClose={() => setIsEditTraderModalOpen(false)}
        showPopup={showPopup}
        fetchData={fetchData}
        API_BASE_URL={API_BASE_URL}
        trader={editTrader}
        userMmdaId={userMmdaId}
        onSuccess={handleOperationSuccess}
        onError={handleOperationError}
      />

      {/* Pagination */}
      {pageCount > 1 && (
        <ReactPaginate
          previousLabel={'previous'}
          nextLabel={'next'}
          breakLabel={'...'}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName={'pagination'}
          activeClassName={'active'}
        />
      )}

      {/* Trader View Info */}
      <div style={{
        marginTop: 20,
        padding: 15,
        backgroundColor: '#e8f5e8',
        borderRadius: 8,
        border: '1px solid #c8e6c9',
        fontSize: 14,
        color: '#2e7d32'
      }}>
        <strong>Trader Management:</strong> As an MMDA admin, you can now register and manage traders within your region.
        Use the Excel import feature for bulk trader registration.
      </div>

      {/* Operation Modals */}
      <OperationModal
        isOpen={showExportModal}
        onClose={() => setShowExportModal(false)}
        type="success"
        title="Export Successful!"
        message="Traders data has been exported successfully."
        details="The Excel file has been downloaded to your Downloads folder. You can now open it with Excel or any spreadsheet application."
      />

      <OperationModal
        isOpen={showAddModal}
        onClose={() => setShowAddModal(false)}
        type="info"
        title="Register New Trader"
        message="Are you sure you want to register a new trader?"
        details="This will open the trader registration form where you can enter the business details and assign them to a zone."
        showCancel={true}
        confirmText="Continue"
        onConfirm={confirmAddTrader}
      />

      <ExcelImportModal
        isOpen={showImportModal}
        onClose={() => setShowImportModal(false)}
        type="traders"
        onImport={handleImport}
        userMmdaId={userMmdaId}
        user={{ user_id: userMmdaId }} // Pass user object with user_id
        fetchData={fetchData}
      />
    </>
  );
};

export default TradersView;
